<template>
	<div class="">
		<el-dialog class="gstdia" :title="$t('app_mot')" :visible.sync="showDia" @close="closeDia">
			<el-form :model="tform" v-loading="loading">
				<el-form-item label :label-width="fwidth">
					<div class="ipeqnum">1</div>
					<div class="ipeqspl"></div>
					<div>
						<label slot="trigger" class="ipeqtt">{{ $t("app_download_template") }}</label>
						<el-button slot="trigger" style="margin-left: 10px;" size="mini" type="primary"
							@click="downTempFile">
							<i class="el-icon-document"></i>
							{{ $t("app_download") }}
						</el-button>
					</div>
					<div class="el-upload__tip" style="font-size: 14px;">{{ $t("app_download_device_message") }}</div>
				</el-form-item>
				<el-form-item label :label-width="fwidth">
					<div class="ipeqnum">2</div>
					<div>
						<!-- :on-change='uploadChange' -->
						<el-upload class="upload-demo" ref="upload" name="file" :multiple="false" :action="saction"
							:headers="header" :before-upload="uploadBefore" :on-success="uploadSuccess"
							:on-change="uploadChange" :show-file-list="false" :auto-upload="false">
							<label slot="trigger" class="ipeqtt">{{ $t("app_upload_template") }}</label>
							<el-button slot="trigger" style="margin-left: 10px;" size="mini" type="primary">
								<i class="el-icon-upload2"></i>
								{{ $t("app_upload") }}
							</el-button>
							<label slot="trigger" style="margin-left: 10px;">{{cfile?cfile.name:$t("app_unupload_file")}}</label>
							<div slot="tip" class="el-upload__tip" style="font-size: 14px;">{{ $t("app_upload_completed_device") }}</div>
						</el-upload>
					</div>
					<div></div>
				</el-form-item>

				<el-form-item :label-width="fwidth">
					<el-button @click="showDia = false">{{ $t("app_cancel") }}</el-button>
					<el-button :disabled="!ready" type="primary" @click="submitUpload">{{ $t("app_imp") }}</el-button>
				</el-form-item>
			</el-form>

		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				loading: false,
				fwidth: "60px",
				showDia: false,
				tform: {},
				ready: false,
				cfile: "",
				header: {},
				pid: ''
			};
		},
		computed: {
			saction() {
				// 
				return this.$taipAction();
			},
		},
		props: ["ctotal", "config"],
		watch: {
			//// 0.equipement 1.agent 2.upgradedetail 3.merchant(商户)
			config(n) {
				this.showDia = n.showDia;
				this.pid = n.pid
			},
		},
		methods: {
			closeDia() {
				this.loading = false;
				this.ready = false;
				this.showDia = false;
				this.cfile = "";
				this.$refs.upload.clearFiles();
			},
			submitUpload() {
				this.$refs.upload.submit();
				// this.$refs.upload.submit();   clearFiles
			},
			uploadChange(file, fileList) {
				// console.log(file, fileList)
				this.cfile = file;
				this.ready = file ? true : false;
			},
			uploadBefore(file) {
				var parts = file.name.split(".");
				var tail = parts.length > 1 ? parts[parts.length - 1] : "";
				if (tail == "xlsx" || tail == "xls") {
					this.loading = true;
					return true;
				} else {
					this.$message.error(this.$t("app_file_invalid"));
					this.closeDia();
					return false;
				}
				// console.log('before', file)
			},
			uploadSuccess(res, raw) {
				this.loading = false;
				this.closeDia();
				if (this.config.callback) this.config.callback(res.data);
				if (res.status == 200) {
					this.$message.success(res.message);
				} else {
					this.$message.error(res.message);
				}
			},
			downTempFile() {
				this.$getTaTempFile()
			},
		},
		mounted() {
			// console.log(this.$getTmp('user'))
			this.header = {
				token: localStorage.token,
			};
			this.pid = this.config.pid
		},
	};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.ipeqnum {
		width: 32px;
		height: 32px;
		line-height: 32px;
		text-align: center;
		position: absolute;
		border: 1px solid rgba(0, 0, 0, 0.15);
		color: rgba(0, 0, 0, 0.25);
		font-weight: 400;
		left: -48px;
		border-radius: 32px;
	}

	.ipeqspl {
		height: 34px;
		width: 1px;
		left: -32px;
		top: 55px;
		position: absolute;
		background: rgba(0, 0, 0, 0.15);
	}

	.ipeqspl1 {
		height: 34px;
		width: 1px;
		left: -32px;
		top: -55px;
		position: absolute;
		background: rgba(0, 0, 0, 0.15);
	}

	.ipeqspl2 {
		height: 17px;
		width: 1px;
		left: -32px;
		top: -22px;
		position: absolute;
		background: rgba(0, 0, 0, 0.15);
	}

	.ipeqtt {
		font-size: 16px;
		color: rgba(0, 0, 0, 0.85);
	}
</style>
